import React, { forwardRef, useState } from "react";
import phone from "../../images/l-phone.svg";
import mail from "../../images/l-mail.svg";
import app from "../../images/l-app.svg";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useMutation } from "@apollo/react-hooks";
import { SEND_LEFT_MAIL } from "../../mutation/sendLeftMail";
import { SEND_RIGHT_MAIL } from "../../mutation/sendRightMail";
import { userClient } from "../../apolloClient";
import SuccessModal from "../../components/Common/ReferralSuccessModal";

const Contact = () => {
  const [phoneN, setPhone] = useState("");
  const [mailLeft, setMailLeft] = useState("");
  const [date, setDate] = useState(null);
  const [mailRight, setMailRight] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [leftMendateError, setLeftMendateError] = useState(false);
  const [rightMendateError, setRigthMendateError] = useState(false);
  const [leftMailError, setLeftMailError] = useState(false);
  const [rightMailError, setRigthMailError] = useState(false);
  const [isInviteSuccess, setIsInviteSuccess] = React.useState(false);

  const [sendLeftMail] = useMutation(SEND_LEFT_MAIL, {
    client: userClient,
  });

  const [sendRightMail] = useMutation(SEND_RIGHT_MAIL, {
    client: userClient,
  });

  function validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  function handleSubmitLeft() {
    if (phoneN && mailLeft && date) {
      if (validateEmail(mailLeft)) {
        setLeftMailError(false);
        sendLeftMail({
          variables: {
            email: mailLeft,
            mobile_number: phoneN,
            date: moment(date).format("YYYY-MM-DD"),
          },
        })
          .then(() => {
            setMailLeft("");
            setPhone("");
            setDate(null);
            setIsInviteSuccess(true);
          })
          .catch(() => {});
      } else {
        setLeftMailError(true);
      }
      setLeftMendateError(false);
    } else {
      setLeftMendateError(true);
    }
  }

  function handleSubmitRight() {
    if (name && mailRight && subject && message) {
      if (validateEmail(mailRight)) {
        setRigthMailError(false);
        sendRightMail({
          variables: {
            name: name,
            email: mailRight,
            subject: subject,
            message: message,
          },
        })
          .then(() => {
            setName("");
            setMailRight("");
            setSubject("");
            setMessage("");
            setIsInviteSuccess(true);
          })
          .catch(() => {});
      } else {
        setRigthMailError(true);
      }
      setRigthMendateError(false);
    } else {
      setRigthMendateError(true);
    }
  }

  const CustomInput = forwardRef(({ value, onClick }, ref) => {
    return (
      <>
        <input
          type="text"
          className="form-control"
          onClick={() => {
            onClick();
          }}
          value={date ? moment(date).format("DD/MM/YYYY") : ""}
          ref={ref}
        />
        <img src={app} alt="phone" />
      </>
    );
  });

  return (
    <>
      <SuccessModal
        show={isInviteSuccess}
        onHide={() => {
          setIsInviteSuccess(false);
        }}
        message="Mail Sent Successfully."
        isContact={true}
      />
      <section className="contact-section" id="contact">
        <div className="container">
          <h2>Get in touch with us!</h2>
          <div className="contact-row">
            <div className="contact-inner">
              <div className="contact-left">
                <div className="form-left">
                  <h2>Fill in the form or drop us an email</h2>
                  <div className="form-group">
                    <input
                      type="number"
                      className="form-control"
                      onChange={(e) => {
                        if (e.target.value.length <= 10) {
                          setPhone(e.target.value);
                        }
                      }}
                      value={phoneN}
                    />
                    <img src={phone} alt="phone" />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      onChange={(e) => {
                        setMailLeft(e.target.value);
                      }}
                      value={mailLeft}
                    />
                    <img src={mail} alt="phone" />
                  </div>
                  <div className="form-group">
                    <DatePicker
                      selected={date}
                      dropdownMode="select"
                      autoComplete="off"
                      onChange={(value) => {
                        setDate(value);
                      }}
                      className="react-time-input"
                      calendarClassName="react-time-picker"
                      popperClassName="react-time-propper"
                      customInput={<CustomInput />}
                    />
                  </div>
                  {leftMendateError ? (
                    <p className="error-message">*All fields are mandatory</p>
                  ) : (
                    ""
                  )}
                  {leftMailError ? (
                    <p className="error-message">*Email not valid</p>
                  ) : (
                    ""
                  )}
                  <div className="form-submit">
                    <button
                      className="submit-btn"
                      onClick={() => {
                        handleSubmitLeft();
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              <div className="contact-right">
                <div className="contact-right-cover">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Name"
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      value={name}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Email"
                      onChange={(e) => {
                        setMailRight(e.target.value);
                      }}
                      value={mailRight}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Subject"
                      onChange={(e) => {
                        setSubject(e.target.value);
                      }}
                      value={subject}
                    />
                  </div>
                  <div className="form-group">
                    <textarea
                      placeholder="Message"
                      className="form-control"
                      onChange={(e) => {
                        setMessage(e.target.value);
                      }}
                      value={message}
                    ></textarea>
                  </div>
                  {rightMendateError ? (
                    <p className="error-message">*All fields are mandatory</p>
                  ) : (
                    ""
                  )}
                  {rightMailError ? (
                    <p className="error-message">*Email not valid</p>
                  ) : (
                    ""
                  )}
                  <div className="form-submit">
                    <button
                      className="submit-btn"
                      onClick={() => {
                        handleSubmitRight();
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
